import { LEAD_GENERATION_FORM_CONFIG_KEYS } from "../../constants/app-constants";
import { LOGIN_SOURCE } from "../../au-c2b/constants/app-constants";

export const LEAD_GENERATION_MODAL_FLOW_CONFIG_KEYS = [
    LEAD_GENERATION_FORM_CONFIG_KEYS.DEFAULT,
    LEAD_GENERATION_FORM_CONFIG_KEYS.COMING_SOON,
    LEAD_GENERATION_FORM_CONFIG_KEYS.TEST_DRIVE
];

export const LEAD_FLOW_TYPES = {
    DEFAULT: "default",
    CLASSIFIED: "classified",
    COMING_SOON: "comingSoon",
    VTD: "vtd"
};

export const getLeadGenerationFlowState = (loginPopupAdditionalInfo = {}) => {
    const { loginSource, leadGenerationConfigKey } = loginPopupAdditionalInfo || {};
    const isComingSoonLeadFlow = leadGenerationConfigKey === LEAD_GENERATION_FORM_CONFIG_KEYS.COMING_SOON
        || loginSource === LOGIN_SOURCE.COMING_SOON;
    const isClassifiedsFlow = !isComingSoonLeadFlow
        && leadGenerationConfigKey === LEAD_GENERATION_FORM_CONFIG_KEYS.DEFAULT
        && loginSource === LOGIN_SOURCE.CLASSISFIEDS;
    const isLeadGenerationFlow = isClassifiedsFlow
        || isComingSoonLeadFlow
        || LEAD_GENERATION_MODAL_FLOW_CONFIG_KEYS.includes(leadGenerationConfigKey);

    return {
        isComingSoonLeadFlow,
        isClassifiedsFlow,
        isLeadGenerationFlow
    };
};

export const getLeadGenerationFlowType = (loginPopupAdditionalInfo = {}) => {
    const { isComingSoonLeadFlow, isClassifiedsFlow } = getLeadGenerationFlowState(loginPopupAdditionalInfo);
    if (isComingSoonLeadFlow) {
        return LEAD_FLOW_TYPES.COMING_SOON;
    }
    if (isClassifiedsFlow) {
        return LEAD_FLOW_TYPES.CLASSIFIED;
    }
    return LEAD_FLOW_TYPES.DEFAULT;
};

export const getLeadGenerationFormConfig = (
    cmsConfig = {},
    configKey = LEAD_GENERATION_FORM_CONFIG_KEYS.DEFAULT
) => {
    const pageSections = cmsConfig?.data?.pageSections || cmsConfig?.pageSections || [];
    const leadGenSection = pageSections.find(
        (section) => section?.pageSection?.name === "LEAD_GENERATION_FORM"
    );
    const meta = leadGenSection?.pageSection?.meta || cmsConfig?.data?.LEAD_GENERATION_FORM || cmsConfig?.LEAD_GENERATION_FORM || cmsConfig || {};

    return meta?.[configKey] || meta?.[LEAD_GENERATION_FORM_CONFIG_KEYS.DEFAULT] || meta;
};
